export const environment = {
  production: false,
  authServiceUrl: 'https://sk-test.internal.sparbankensyd.se/service',
  compricerApi: 'https://sk-test.internal.sparbankensyd.se/api',
  domain: 'sk-stage.internal.sparbankensyd.se', // We use sharp BankID
  // authServiceUrl: 'https://spb-common-api-test.internal.sparbankensyd.se/service',
  // compricerApi: 'https://api-savings-account-martin.internal.sparbankensyd.se/api',
  // domain: 'sk-test.internal.sparbankensyd.se',
  testMode: true
}
